<template>
  <b-modal
    id="confirmation-modal"
    v-model="openModal"
    size="md"
    :title="confirmation.title"
  >
    <div>
      <b-overlay
        id="overlay-background"
        :show="loading"
        :variant="'white'"
        :opacity="0.7"
        :blur="'2px'"
        rounded="sm"
      >
        <p>
          {{ confirmation.content }}
        </p>
        <p>{{ $t('modals.confirmation') }}</p>
      </b-overlay>
    </div>
    <template #modal-footer>
      <div class="w-100">
        <b-button
          variant="outline-secondary"
          class="float-left"
          @click="close"
        >
          {{ $t('buttons.cancel') }}
        </b-button>
        <b-button
          variant="primary"
          class="float-right"
          @click="trigger"
        >
          {{ $t('words.validate') }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import modal from '@/utils/modal.js';

export default {
  name: 'ConfirmationModal',

  data() {
    return {
      loading: false
    }
  },

  computed: {
    confirmation() {
      return modal.state.confirmation;
    },
    openModal: {
      get() {
        return modal.state.confirmation.open;
      },
      set(value) {
        if (!value) {
          modal.closeConfirmation();
        }
      }
    }
  },

  methods: {
    resetModal() {
      // keep local loading state reset
      this.loading = false;
    },
    trigger() {
      modal.triggerConfirmation();
    },
    close() {
      modal.closeConfirmation();
    }
  }
}
</script>